import React, { useEffect, useState } from 'react';

const THEMES = [
  { id: 'light', label: 'Light', symbol: '☀' },
  { id: 'dark',  label: 'Dark',  symbol: '☽' },
];

const getInitialTheme = () => {
  const stored = localStorage.getItem('portfolio-theme');
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const ThemeToggle = () => {
  const [active, setActive] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', active);
    localStorage.setItem('portfolio-theme', active);
  }, [active]);

  return (
    <div className="theme-toggle" role="group" aria-label="Select colour theme">
      {THEMES.map(({ id, label, symbol }) => (
        <button
          key={id}
          className={`theme-toggle-btn${active === id ? ' active' : ''}`}
          onClick={() => setActive(id)}
          aria-pressed={active === id}
          title={label}
        >
          <span className="theme-toggle-symbol" aria-hidden="true">{symbol}</span>
          <span className="theme-toggle-label">{label}</span>
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
